import { type ContractModel } from "@doitintl/cmp-models";

export const getCommitmentTypeText = (contract: ContractModel): string => {
  if (contract.isCommitment) {
    return "Hard commit";
  }
  if (contract.isSoftCommitment) {
    return "Soft commit";
  }
  return "On-demand";
};

export const getContractStatus = (contract: ContractModel) => {
  const now = new Date();

  switch (true) {
    case contract.active && !contract.terminated:
      if ((contract.isCommitment || contract.isSoftCommitment) && contract.endDate && now > contract.endDate.toDate()) {
        return "expired";
      }
      return "active";

    case !contract.active && !contract.terminated && contract.startDate.toDate() > now:
      return "inactive";

    case !contract.active && !contract.terminated:
      return "canceled";

    case !contract.active && contract.terminated:
      return "terminated";
  }
};
